var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-container" }, [
    _c("div", { staticClass: "container-responsive" }, [
      _vm.displayPanel
        ? _c(
            "div",
            { staticClass: "row" },
            [
              _vm.displayPanel.card_widget_info[0].cardType === "headline" &&
              _vm.displayPanel.card_widget_info[0].card_number === 1
                ? _c("carousel-widget", {
                    attrs: { isDefault: _vm.isDefault },
                    on: {
                      openAddPopup: function ($event) {
                        return _vm.openAddPopup()
                      },
                      openEditPopup: function ($event) {
                        return _vm.openEditPopup("Main Headline")
                      },
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-4" },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.displayPanel.card_widget_info, function (panel) {
                      return _c("div", { key: panel.card_number }, [
                        panel.cardType === "single" &&
                        [2, 3].includes(panel.card_number)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-sm-6 col-md-6 col-lg-12",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "widget-card widget-margin-bottom-25 single-widget-ht",
                                    class: {
                                      "pd-24": [12, 13, 17].includes(
                                        panel.panel_widget_id
                                      ),
                                    },
                                  },
                                  [
                                    _c("single-card-component", {
                                      attrs: {
                                        panel: panel,
                                        sbData: _vm.sbData,
                                        sxData: _vm.sxData,
                                        permissions: _vm.permissions,
                                      },
                                    }),
                                    panel.panel_widget_id != 3
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 footer bt-32 rt-24",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "seeMore",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.redirect(
                                                      panel.panel_widget_id
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("See All")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    }),
                    0
                  ),
                ]
              ),
              _vm._l(_vm.displayPanel.card_widget_info, function (panel) {
                return _c("div", { key: panel.card_number }, [
                  panel.card_number != 1 &&
                  panel.card_number != 2 &&
                  panel.card_number != 3
                    ? _c(
                        "div",
                        {
                          class: {
                            "col-xs-12 col-sm-12 col-md-12 col-lg-4":
                              panel.cardType === "single",
                            "col-xs-12 col-sm-12 col-md-12 col-lg-6":
                              panel.cardType === "combo",
                            "col-xs-12 col-sm-12 col-md-12 col-lg-12":
                              panel.cardType === "horizontal",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "row p-relative",
                              class: {
                                "widget-card": panel.cardType !== "horizontal",
                                "combo-widget-ht": panel.cardType === "combo",
                                "single-widget-ht": panel.cardType === "single",
                                "pd-0": panel.panel_widget_id == 8,
                                "pd-24": [12, 13, 14, 15, 17, 19].includes(
                                  panel.panel_widget_id
                                ),
                                "pd-custom-projects":
                                  panel.panel_widget_id == 16,
                                // 'ht-500': panel.cardType == 'horizontal',
                                "widget-margin-bottom-25":
                                  panel.cardType != "horizontal",
                                "upcoming-widget-pd":
                                  panel.cardType === "combo" &&
                                  panel.panel_widget_id == 3,
                              },
                            },
                            [
                              panel.cardType === "single"
                                ? _c("single-card-component", {
                                    attrs: {
                                      panel: panel,
                                      sbData: _vm.sbData,
                                      sxData: _vm.sxData,
                                      name: panel.displayName,
                                      permissions: _vm.permissions,
                                    },
                                  })
                                : _vm._e(),
                              panel.cardType === "combo"
                                ? _c("combo-card-component", {
                                    attrs: {
                                      panel: panel,
                                      sbData: _vm.sbData,
                                      sxData: _vm.sxData,
                                      name: panel.displayName,
                                      type: "combo",
                                      permissions: _vm.permissions,
                                    },
                                  })
                                : _vm._e(),
                              panel.cardType === "horizontal"
                                ? _c("horizontal-card-component", {
                                    attrs: {
                                      panel: panel,
                                      sbData: _vm.sbData,
                                      sxData: _vm.sxData,
                                      permissions: _vm.permissions,
                                    },
                                  })
                                : _vm._e(),
                              panel.panel_widget_id != 3
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "col-md-12 footer",
                                      class: {
                                        // 'pr-0': panel.cardType != 'horizontal',
                                        "pr-0": panel.cardType == "combo",
                                        "bt-32 rt-25":
                                          panel.cardType == "single",
                                        "bt-10 rt-25":
                                          panel.cardType === "horizontal",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "seeMore",
                                          on: {
                                            click: function ($event) {
                                              return _vm.redirect(
                                                panel.panel_widget_id
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("See All")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }